import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { MultipleFilesUploadModal, TableBox } from "@/components";
import React, { useState } from "react";

export const DeveloperModals = () => {
  const [openMultipleFilesUploadModal, setOpenMultipleFilesUploadModal] =
    useState(false);

  const multipleFilesUploadClick = () => {
    setOpenMultipleFilesUploadModal(true);
  };

  const handleMultipleFilesUploadClose = () => {
    setOpenMultipleFilesUploadModal(false);
  };

  return (
    <>
      <Typography variant="h2">Modals under development</Typography>
      <TableBox>
        <Box>
          <Button
            variant="contained"
            onClick={multipleFilesUploadClick}
            sx={{ color: "primary" }}
          >
            Multiple files upload
          </Button>
        </Box>
      </TableBox>
      <MultipleFilesUploadModal
        open={openMultipleFilesUploadModal}
        handleClose={handleMultipleFilesUploadClose}
      />
    </>
  );
};
